import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  [ORDER_METHODS.delivery]: 'Lieferung',
  [ORDER_METHODS.pickup]: 'Abholung',
  [ORDER_METHODS.room_service]: 'Zimmerservice',
};
